// components/ShareButton.tsx
import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { SharePopup } from './SharePopup';
import { ExperienceType } from '@/components/experience-detail/types';
import { useShare } from '@/hooks/useShare';

interface ShareButtonProps {
  type?: ExperienceType;
  slug?: string;
  /** When true, share and copy the full current URL (e.g. with ?booking=). */
  useFullUrl?: boolean;
}

const ShareButton: React.FC<ShareButtonProps> = ({
  type,
  slug,
  useFullUrl,
}) => {
  const [isClient, setIsClient] = useState(false);
  const {
    openSharePopup,
    shareUrl,
    popupOpen,
    setPopupOpen,
    shareTitle,
    shareDescription,
    loading,
  } = useShare({ type, slug, useFullUrl });

  // Ensure component only renders interactive features on client-side
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Don't render the button during SSR
  if (!isClient) {
    return (
      <button disabled className='p-0'>
        <Image
          src='/assets/images/icons/share-icon.svg'
          alt='Share'
          width={20}
          height={20}
        />
      </button>
    );
  }

  return (
    <>
      <button
        type='button'
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          openSharePopup();
        }}
        disabled={loading}
        className='p-2 flex items-center justify-center rounded-full aspect-square hover:bg-gray-100 active:bg-gray-200 transition-colors'
      >
        <Image
          src='/assets/images/icons/share-icon.svg'
          alt='Share'
          width={20}
          height={20}
        />
      </button>

      <SharePopup
        open={popupOpen}
        onOpenChange={setPopupOpen}
        shareUrl={shareUrl}
        title={shareTitle}
        description={shareDescription}
      />
    </>
  );
};

export default ShareButton;
